@if (isMobile()) {
    @for (row of knoxEvents; track row;) {
		<div class="list-card d-flex flex-column mb-3 w-100 list-parent-container">
			<div class="d-flex flex-row justify-content-between align-items-center w-100 list-header">
				<div class="unique-field2">
					<h4 class="p-2">{{ row.eventDateStr }}</h4>					
				</div>
			</div>
			<div>
				<div class="list-field">
                    <div class="card-list-item2">
                        <p>Location</p>
                        <h6>{{ row.location }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Med Vault Serial #</p>
                        <h6>{{ row.medVaultSerialNumber }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Box Serial #</p>
                        <h6>{{ row.boxSerialNumber }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Event Category</p>
                        <h6>{{ row.eventCategory }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Report Date</p>
                        <h6>{{ row.reportingDateStr }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>User Name</p>
                        <h6>{{ row.userName }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>User Id</p>
                        <h6>{{ row.userId }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Med Vault Firmware</p>
                        <h6>{{ row.medVaultFirmware }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>Knox Event Id</p>
                        <h6>{{ row.knoxEventId }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>S2 Event Type</p>
                        <h6>{{ row.inventoryActionsEnumStr }}</h6>
                    </div>
                    <div class="card-list-item2">
                        <p>S2 Event Date</p>
                        <h6>{{ row.actionDateStr }}</h6>
                    </div>
                </div>
			</div>
		</div>
	}
} @else {
    <table class="data-grid">
        <thead>
            <tr>
                <td>Event Date</td>
                <td>Location</td>
                <td>Med Vault Serial #</td>
                <td>Box Serial #</td>
                <td>Event Category</td>
                <td>Report Date</td>
                <td>User Name</td>
                <td>User Id</td>
                <td>Med Vault Firmware</td>
                <td>Knox Event Id</td>
                <td>S2 Event Type</td>
                <td>S2 Event Date</td>
            </tr>
        </thead>
        <tbody>
            @for (row of knoxEvents; track row;) {
                <tr>
                    <td>{{ row.eventDateStr }}</td>
                    <td>{{ row.location }}</td>
                    <td>{{ row.medVaultSerialNumber }}</td>
                    <td>{{ row.boxSerialNumber }}</td>
                    <td>{{ row.eventCategory }}</td>
                    <td>{{ row.reportingDateStr }}</td>
                    <td>{{ row.userName }}</td>
                    <td>{{ row.userId }}</td>
                    <td>{{ row.medVaultFirmware }}</td>
                    <td>{{ row.knoxEventId }}</td>
                    <td>{{ row.inventoryActionsEnumStr }}</td>
                    <td>{{ row.actionDateStr }}</td>
                </tr>
            }
        </tbody>
    </table>
}